/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as global from "../../js/global" ;
	import * as helper from "../../js/helper";
	import full_loading from "../components/full-loading.vue";
    import VueSelect from '../../js/vue-select.js';
	const __vue_script__ ={
        components: {
            full_loading:full_loading,
            vue_select:VueSelect,
        },
		name:'map_search_widget',
        props: { 
            property_json: {
                type: String,
            },
            property_name: {
                type: String,
            }
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading:false,
				property: null,
                main_building: true,
                floor_index: "",
                children: null,
                child_property_name: "",
                ad_type_color: '#0000ff',
                property_type_icon: '#0000ff',
                amount: 0,
                type: null,
                description: "",
			}
		},
        mounted(){
            var exampleModal = document.getElementById('addExpenseModal')
            exampleModal.addEventListener('show.bs.modal', this.load_property_data)
        },
		methods: {
            load_property_data: async function(event){
                this.loading = true;
				this.property = null;
                this.main_building = true;
                this.floor_index = "";
                this.children = null;
                this.type = null;
                this.amount = 0;
                this.description= "";
                // Button that triggered the modal
                var button = event.relatedTarget;
                // Extract info from data-bs-* attributes
                this.property_name = button.getAttribute('data-bs-property-name');
                this.form_sent = true;
                let params = {
                    property_name : this.property_name
                };
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.get_property_with_children",
                        type: "GET",
                        data: params //for GET request
                        // data: JSON.stringify(params) //for POST request
                    });
                    this.property = res.message
                    this.loading = false
                    this.ad_type_color = global.global_params.ad_type_colors[this.property.ad_type];
                    this.property_type_icon = global.global_params.map_icons[this.property.property_type][this.property.ad_type];
                    this.$forceUpdate();
                } catch (e) {
                    console.log("failed")
                    console.log(e)
                    var exceptions = helper.showException(e);
                }
                
                this.loading = false
            },
            addExpense: async function(){
                this.form_sent = true;
                let params = {
                    property_name : this.main_building?this.property.name:this.child_property_name,
                    amount :        this.amount,
                    type :          this.type,
                    description :   this.description,
                };
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.add_expense",
                        type: "POST",
                        // data: params //for GET request
                        data: JSON.stringify(params) //for POST request
                    });
                    this.loading = false
                    global.emitter.emit("refresh-expense");
                    $("#addExpenseModal").modal('hide');
                    helper.showSuccess("Expense saved");
                } catch (e) {
                    console.log("failed");
                    console.log(e);
                    var exceptions = helper.showException(e);
                }
                this.loading = false
            }
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade filter-popup-area",
      attrs: {
        id: "addExpenseModal",
        "data-bs-backdrop": "static",
        "data-bs-keyboard": "false",
        tabindex: "-1",
        "aria-labelledby": "staticBackdropLabel",
        "aria-hidden": "true"
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog modal-dialog-centered modal-dialog-scrollable"
        },
        [
          _vm.property == null
            ? _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "staticBackdropLabel" }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.helper.t("Loading... Please wait.")) +
                          " "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "btn-close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close"
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.property != null
            ? _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "staticBackdropLabel" }
                    },
                    [
                      _c("img", {
                        staticClass: "icon",
                        attrs: { src: _vm.property_type_icon }
                      }),
                      _vm._v(_vm._s(_vm.property.name))
                    ]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "btn-close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _vm.property.floors.length > 0
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [
                              _vm._v(" " + _vm._s(_vm.helper.t("Expense For")))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-check",
                                    on: {
                                      click: function($event) {
                                        _vm.main_building = true
                                      }
                                    }
                                  },
                                  [
                                    _c("input", {
                                      staticClass: "form-check-input",
                                      attrs: {
                                        type: "checkbox",
                                        id: "flexCheckDefault"
                                      },
                                      domProps: { checked: _vm.main_building }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { staticClass: "form-check-label" },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(
                                              _vm.helper.t("Main Building")
                                            ) +
                                            "\n                                        "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-check",
                                    on: {
                                      click: function($event) {
                                        _vm.main_building = false
                                      }
                                    }
                                  },
                                  [
                                    _c("input", {
                                      staticClass: "form-check-input",
                                      attrs: {
                                        type: "checkbox",
                                        id: "flexCheckDefault"
                                      },
                                      domProps: { checked: !_vm.main_building }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { staticClass: "form-check-label" },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(
                                              _vm.helper.t("Sub Building")
                                            ) +
                                            "\n                                        "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.main_building
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.floor_index,
                                    expression: "floor_index"
                                  }
                                ],
                                staticClass:
                                  "form-select form-control border-radius",
                                attrs: {
                                  "aria-label": "Default select example"
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.floor_index = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(_vm._s(_vm.helper.t("Select Floor")))
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.property.floors, function(floor) {
                                  return _c(
                                    "option",
                                    { domProps: { value: floor.floor_num } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          floor.floor_num == 0
                                            ? _vm.helper.t("Ground Floor")
                                            : _vm.helper.t("Floor {0}", [
                                                floor.floor_num
                                              ])
                                        )
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.floor_index !== ""
                          ? _c("div", { staticClass: "col-6" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-check",
                                  on: {
                                    click: function($event) {
                                      _vm.main_building = false
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.child_property_name,
                                          expression: "child_property_name"
                                        }
                                      ],
                                      staticClass:
                                        "form-select form-control border-radius",
                                      attrs: {
                                        "aria-label": "Default select example"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.child_property_name = $event
                                            .target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.helper.t("Select Sub Property")
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.property.floors[_vm.floor_index]
                                          .children,
                                        function(child) {
                                          return _c(
                                            "option",
                                            { domProps: { value: child.name } },
                                            [
                                              _vm._v(_vm._s(child.title) + " "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    child.is_occupied
                                                      ? "(0" +
                                                          child.occupent.substring(
                                                            4
                                                          ) +
                                                          ")"
                                                      : ""
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.helper.t("Add Expense")))
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.amount,
                              expression: "amount"
                            }
                          ],
                          staticClass: "form-control border-radius",
                          attrs: { type: "number" },
                          domProps: { value: _vm.amount },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.amount = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.helper.t("Expense Type")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.type,
                                expression: "type"
                              }
                            ],
                            staticClass:
                              "form-select form-control border-radius",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.type = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { domProps: { value: null } }, [
                              _vm._v(_vm._s(_vm.helper.t("Select")))
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "Maintenance" } }, [
                              _vm._v(_vm._s(_vm.helper.t("Maintenance")))
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "Utility" } }, [
                              _vm._v(_vm._s(_vm.helper.t("Utility")))
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "Construction" } }, [
                              _vm._v(_vm._s(_vm.helper.t("Construction")))
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "Other" } }, [
                              _vm._v(_vm._s(_vm.helper.t("Other")))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.helper.t("Expense Description")))
                        ]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.description,
                              expression: "description"
                            }
                          ],
                          staticClass: "form-control border-radius",
                          attrs: { cols: "30", rows: "6", maxlength: "255" },
                          domProps: { value: _vm.description },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.description = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("small", [
                          _vm._v(_vm._s(_vm.helper.t("Max. {0}", [255])))
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.amount > 0 &&
                  _vm.type &&
                  (_vm.main_building ||
                    (!_vm.main_building && _vm.child_property_name.length > 0))
                    ? _c(
                        "a",
                        {
                          staticClass: "btn default-btn mt-2",
                          attrs: { role: "button" },
                          on: { click: _vm.addExpense }
                        },
                        [
                          _c("p", [
                            _vm._v(_vm._s(_vm.helper.t("Save")) + " "),
                            _c("i", {
                              staticClass: "fa-solid fa-paper-plane fa-lg"
                            })
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-2e2b282c_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"add-expense-modal.vue"}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/modal/add-expense-modal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__